import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getCompanyEmployees,
  deleteCompanyEmployee,
} from "../actions/companyActions";

import { Button } from "@material-ui/core";

import DataListWithSearchFilter from "./DataListWithSearchFilter";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class CompanyEmployeeList extends Component {
  state = {
    employees: [],
  };

  componentDidMount() {
    this.refreshData();
  }

  deleteCompanyEmployee(companyEmail, employeeEmail) {
    this.props.deleteCompanyEmployee(companyEmail, employeeEmail).then(() => {
      this.setState({
        employees: this.state.employees.filter((g) => g.email != employeeEmail),
      });
    });
  }

  refreshData = () => {
    this.setState({ employees: [] });

    this.props.getCompanyEmployees(this.props.company).then((employees) => {
      this.setState({ employees: employees.filter((e) => e.isActive) });
    });
  };

  render() {
    return (
      <Fragment>
        <Button variant="contained" color="primary" onClick={this.refreshData}>
          Zoek
        </Button>

        <DataListWithSearchFilter
          data={this.state.employees.map((employee) => {
            return {
              id: employee.email,
              avatar: new Buffer(employee.facePhoto, "base64").toString(
                "binary",
              ),
              title: `${employee.firstName} ${employee.lastName}`,
              subtitle: employee.email,
              onClick: () =>
                (window.location.href = `/company/${this.props.company}/employee/${employee.email}`),
              ctxMenu: [
                {
                  label: "Wijzigen",
                  action: () =>
                    (window.location.href = `/company/${this.props.company}/employee/${employee.email}/update`),
                },
                {
                  label: "Verwijderen",
                  action: () =>
                    this.deleteCompanyEmployee(
                      this.props.company,
                      employee.email,
                    ),
                  confirm: true,
                  hide: !credentials.user.isAdmin,
                },
              ],
            };
          })}
          isFetching={this.props.isFetching}
          successMessage={this.props.successMessage}
          errorMessage={this.props.errorMessage}
        />
      </Fragment>
    );
  }
}

CompanyEmployeeList.propTypes = {
  company: PropTypes.string.isRequired,
  getCompanyEmployees: PropTypes.func.isRequired,
  deleteCompanyEmployee: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.company.deleteCompanyEmployee.successMessage,
  errorMessage: state.company.deleteCompanyEmployee.errorMessage,
  isFetching:
    state.company.getCompanyEmployees.isFetching ||
    state.company.deleteCompanyEmployee.isFetching,
});

export default connect(mapStateToProps, {
  getCompanyEmployees,
  deleteCompanyEmployee,
})(CompanyEmployeeList);



// WEBPACK FOOTER //
// ./src/components/CompanyEmployeeList.js